import { useEffect } from 'react';
import confetti from 'canvas-confetti';
import { useReducedMotion } from 'framer-motion';

import { colors } from '../styles';

/** Confete quando um grupo ganha um novo 1º lugar (FE-14). */
export default function useLeaderConfetti(
  newLeaders: string[],
  effectsKey: number,
): void {
  const reduceMotion = useReducedMotion();

  useEffect(() => {
    if (reduceMotion || newLeaders.length === 0 || effectsKey === 0) return;

    const shoot = (x: number) =>
      confetti({
        particleCount: 140,
        spread: 80,
        startVelocity: 50,
        origin: { x, y: 0.35 },
        colors: [colors.gold, colors.accent, colors.blue, '#ffffff'],
        disableForReducedMotion: true,
      });

    shoot(0.25);
    const timer = setTimeout(() => shoot(0.75), 250);
    return () => clearTimeout(timer);
  }, [effectsKey]);
}
